export default "__VITE_ASSET__CV30b8GB__"